import { render, staticRenderFns } from "./ozelbilgiler.vue?vue&type=template&id=5f25e40a&"
import script from "./ozelbilgiler.vue?vue&type=script&lang=js&"
export * from "./ozelbilgiler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports